import PropertiesConstants from './PropertiesConstants';

const LISTING_TYPES = {
  RENTAL: 'For Rent',
  ROOM: 'Room for Rent',
  SALE: 'For Sale',
} as const;

const LISTING_STATUS = {
  PENDING: 'Pending',
  POSTED: 'Posted',
  DECLINED: 'Declined',
  PUBLISHING: 'Publishing',
  INACTIVE: 'Inactive',
} as const;

const SYNDICATION_OVERVIEW_STATUS = {
  INACTIVE: 'inactive',
  PUBLISHING: 'publishing',
  PUBLISHED: 'published',
  PARTIALLY_PUBLISHED: 'partiallyPublished',
  DECLINED: 'declined',
  WAITLISTED: 'waitlisted',
};

const PROPERTY_TYPES = {
  COMMUNITY: 'Entire Apartment Community',
  CONDO: 'Condo / Apartment Unit',
  MULTIPLEX: 'Apartment units',
  HOUSE: 'House',
  TOWNHOUSE: 'Townhome',
} as const;

const { RENTAL, ROOM, SALE } = LISTING_TYPES;
const { COMMUNITY, CONDO, HOUSE, MULTIPLEX, TOWNHOUSE } = PROPERTY_TYPES;

const LISTING_TYPES_BY_CODE = {
  1: RENTAL,
  2: SALE,
  5: ROOM,
};

const LISTING_CODES_BY_TYPE = {
  [RENTAL]: 1,
  [SALE]: 2,
  [ROOM]: 5,
} as const;

const PROPERTY_TYPES_BY_CODE: Record<number, string> = {
  1: COMMUNITY,
  2: COMMUNITY,
  3: COMMUNITY,
  5: CONDO,
  6: HOUSE,
  7: TOWNHOUSE,
};

const PROPERTY_TYPES_BY_ENUM: Record<string, string> = {
  CONDO: CONDO,
  DIVIDED: COMMUNITY,
  GARDEN: COMMUNITY,
  HOUSE: HOUSE,
  LARGE: COMMUNITY,
  MEDIUM: COMMUNITY,
  TOWNHOUSE: TOWNHOUSE,
};

const PROPERTY_CODES_BY_TYPE = {
  [COMMUNITY]: 1,
  // not currently using these two
  // GARDEN: 2,
  // MEDIUM: 3,
  [CONDO]: 5,
  [HOUSE]: 6,
  [MULTIPLEX]: 5,
  [TOWNHOUSE]: 7,
} as const;

// TODO: replace instances with values from FreemiumConstants
const PRODUCT_TYPE_NAME_TO_ID = {
  FREE: 5,
  PREMIUM: 6,
};

const PRODUCT_TYPE_ID_TO_NAME = {
  5: 'Free',
  6: 'Premium',
};

const ERROR_CODE = {
  IS_MULTI_FAMILY_RESTRICTED: 'isMultiFamilyRestricted',
};

const PROPERTY_TABLE_COLUMNS = {
  ADDRESS: 'header-address',
  RENT: 'header-rent',
  POTENTIAL_TENANTS: 'header-potential-tenants',
  LEASES: 'header-leases',
  ACTIONS: 'header-actions',
} as const;

const RENT_TRIGGERS = {
  'Set up payments': 'setup_payments',
  'View payment': 'view_late_payments',
} as const;

const POTENTIAL_TENANTS_TRIGGERS = {
  'Enable applications': 'enable_applications',
  'List for rent': 'list_for_rent',
  'Edit listing': 'edit_listing',
} as const;

const LEASE_TRIGGERS = {
  'New lease': 'create_new_lease',
  'Create or upload a lease': 'create_new_lease',
  'View lease': 'view_leases',
  'View leases': 'view_leases',
  'Edit draft': 'edit_draft_lease',
  'View drafts': 'view_draft_lease',
  'Send for signing': 'send_for_signing',
  'Renewal options': 'lease_renewal_options',
  'View progress': 'view_signing_progress',
  'View and sign': 'view_and_sign',
} as const;

const FILTER_TRIGGERS = {
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.ALL]: 'all_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.ON_MARKET]: 'for_rent_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.OFF_MARKET]: 'off_market_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.AT_RISK]: 'at_risk_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.ARCHIVED]: 'archived_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.FREE_BONUS_LISTINGS]: 'bonus_properties',
  [PropertiesConstants.PROPERTIES_SUBNAV_FILTER_TYPE.CLAIMED]: 'claimed_properties',
} as const;

const HOVER_TRIGGERS = {
  [PROPERTY_TABLE_COLUMNS.RENT]: 'rent_payments',
  [PROPERTY_TABLE_COLUMNS.POTENTIAL_TENANTS]: 'potential_tenants',
  [PROPERTY_TABLE_COLUMNS.LEASES]: 'leases',
} as const;

const PROPERTY_TABLE_TRIGGER_OBJECT_MAP = {
  RENT_TRIGGERS,
  POTENTIAL_TENANTS_TRIGGERS,
  LEASE_TRIGGERS,
  FILTER_TRIGGERS,
  HOVER_TRIGGERS,
} as const;

const PropertyConstants = {
  LISTING_TYPES,
  LISTING_STATUS,
  PROPERTY_TYPES,
  LISTING_TYPES_BY_CODE,
  LISTING_CODES_BY_TYPE,
  PROPERTY_TABLE_COLUMNS,
  PRODUCT_TYPE_NAME_TO_ID,
  PRODUCT_TYPE_ID_TO_NAME,
  PROPERTY_CODES_BY_TYPE,
  PROPERTY_TYPES_BY_CODE,
  PROPERTY_TYPES_BY_ENUM,
  SYNDICATION_OVERVIEW_STATUS,
  ERROR_CODE,
  PROPERTY_TABLE_TRIGGER_OBJECT_MAP,
};

export default PropertyConstants;
